var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-profile-search filter-product-main-wrapper"},[_c('div',{staticClass:"modal-card filter-form"},[_c('section',{staticClass:"modal-card-body"},[_c('filter-main-content',{attrs:{"sort":_vm.sort,"sizes":_vm.sizes,"activesubcategory":_vm.activesubcategory,"categoryintensity":_vm.categoryintensity,"showheading":true}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }